module.exports = __webpack_public_path__ + "img/outline-text_fields-24px.636797c7.svg";